import { Icon } from '@chakra-ui/react';

const PCHtmlIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<g>
			<g>
				<path class="st0" d="M11.99,27.61c0.67,0.39,0.66,1.48,0,1.8c-1.13,0-2.23,0-3.33,0c-0.96,0-3.9,0.01-4.85,0
			c-1.6-0.02-2.77-1.17-2.77-2.78c-0.01-7.75-0.01-15.5,0-23.24c0-1.64,1.16-2.79,2.81-2.79c4.71-0.01,14.49-0.01,19.2,0.01
			c0.32,0,0.71,0.16,0.94,0.38c1.73,1.69,3.44,3.4,5.14,5.13c0.18,0.19,0.37,0.47,0.38,0.72c0.04,1.2,0.02,2.39,0.02,3.62
			c-0.45,0.56-1.28,0.59-1.77,0c0-0.85,0-1.72,0-2.67c-1.24,0-3.22,1.3-4.4,1.29c-1.08-0.01-1.83-0.77-1.85-1.85
			c-0.01-0.51,0.81-2.3,0.81-2.81c0-0.65,0-1.31,0-2.01c-0.22-0.01-0.4-0.03-0.58-0.03c-4.2,0-13.48,0-17.68,0
			c-0.94,0-1.23,0.29-1.23,1.24c0,7.58,0,15.16,0,22.74c0,0.95,0.29,1.24,1.23,1.24C6.03,27.61,9.98,27.61,11.99,27.61z"/>
			</g>
			<g>
				<path class="st0" d="M7.84,17.71h1.32v3.43h1.42v-3.43h1.32v8.43h-1.32v-3.79H9.16v3.79H7.84V17.71z" />
				<path class="st0" d="M13.93,18.91h-1.39v-1.2h4.09v1.2h-1.38v7.23h-1.32V18.91z" />
				<path class="st0" d="M17.28,17.71h1.89l0.84,6.03h0.02l0.84-6.03h1.89v8.43h-1.25v-6.38h-0.02l-0.96,6.38h-1.11l-0.96-6.38h-0.02
			v6.38h-1.16V17.71z"/>
				<path class="st0" d="M23.76,17.71h1.32v7.23h2.18v1.2h-3.5V17.71z" />
			</g>
		</g>

	</Icon>
);

export default PCHtmlIcon;
